var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', [_vm.character ? _c('v-list-item-avatar', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "size": _vm.$size(),
      "tile": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push("/standpic/".concat(_vm.character.m_ResourceBaseName));
      }
    }
  }, [_vm.character.m_Datas[0].m_FaceReferenceImageType == 0 && _vm.character.m_Datas[0].m_FacePattern != -1 ? _c('v-img', {
    attrs: {
      "src": _vm.$asset.standpic.format(_vm.base, "".concat(_vm.base, "_face_0_default")) + '.png'
    }
  }) : _vm.character.m_Datas[0].m_FaceReferenceImageType == 0 && _vm.character.m_Datas[0].m_FacePattern == -1 ? _c('div', {
    style: _vm.style('standpic_0')
  }) : _vm.character.m_Datas[0].m_FaceReferenceImageType == 1 ? _c('div', {
    style: _vm.style('face_0_default')
  }) : _vm._e()], 1) : _c('v-list-item-avatar', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "size": _vm.$size(),
      "tile": ""
    }
  }), _vm.show_voice() ? _c('div', {
    staticClass: "mr-3"
  }, [_vm.voice_url ? _c('voice', {
    style: "width:".concat(_vm.$size(), "px;height:").concat(_vm.$size(), "px;"),
    attrs: {
      "name": _vm.name,
      "cue": _vm.text.replace('br', '').replace(/s+/g, ''),
      "override_url": _vm.voice_url
    }
  }) : _c('Voice', {
    style: "visibility: hidden;width:".concat(_vm.$size(), "px;height:").concat(_vm.$size(), "px;")
  })], 1) : _vm._e(), _c('v-list-item-content', {
    staticClass: "mr-auto ml-0 py-1",
    staticStyle: {
      "max-width": "384px"
    }
  }, [_c('v-list-item-subtitle', {
    staticClass: "primary--text",
    domProps: {
      "innerHTML": _vm._s(_vm.name)
    }
  }), _c('div', {
    style: {
      'line-height': 1.5,
      'font-size': _vm.$vuetify.breakpoint.xsOnly ? '70%' : null
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }